







import { Component, Vue, Prop } from 'vue-property-decorator';
import IconbarItem from '@/components/IconbarItem.vue';
import IconbarSidepanel from '@/components/IconbarSidepanel.vue';

@Component({components: {IconbarItem, IconbarSidepanel}})
export default class Iconbar extends Vue {
  sidePanelWidth: string = '0';

  closeSidepanel() {
    this.sidePanelWidth = '0';
  }

  openSidepanel() {
    this.sidePanelWidth = '25vw';
  }

}

